module.exports = __webpack_public_path__ + "static/media/banner_teenPatti-half.5fad7b94.png";